import { useCallback } from 'react';
import { observer } from 'mobx-react';
import cls from 'classnames';

import { GO_TO_COMPARE } from '@/analytics/services/Analytics';
import { useAnalyticsStore } from '@/analytics/store/AnalyticsStore';
import Icon from '@/common/components/Icon/Icon';
import Label, { ACCENT, SIZE_MEDIUM } from '@/common/components/Label/Label';
import Link, { NONE } from '@/common/components/Link/Link';
import URLProvider from '@/common/services/URLProvider';
import { useAppStore } from '@/common/stores/AppStore';
import { useComparisonStore } from '@/comparison/stores/ComparisonStore';

import headerStyles from '../Header.module.css';

function ComparisonNavItem() {
  const { sendEventWithContext } = useAnalyticsStore();
  const { productTypeContext } = useAppStore();
  const { productIds, productsCount } = useComparisonStore();

  const handleCompareClick = useCallback(() => {
    sendEventWithContext(GO_TO_COMPARE);
  }, [sendEventWithContext]);

  const comparisonPageURL = URLProvider.comparisonPage(productIds, productTypeContext);
  const isComparisonPageAccessible = productTypeContext && comparisonPageURL;

  return (
    <Link
      key={1}
      appearance={NONE}
      aria-disabled={isComparisonPageAccessible ? 'false' : 'true'}
      aria-label="Link to comparison page"
      className={cls(headerStyles.headerLink, headerStyles.headerLinkIcon)}
      onClick={handleCompareClick}
      to={isComparisonPageAccessible ? comparisonPageURL : ''}
    >
      <Icon name="compare" />

      {productsCount > 0 && (
        <Label
          className={headerStyles.headerLinkLabel}
          appearance={ACCENT}
          aria-label="Number of products in comparison"
          aria-live="assertive"
          rounded
          size={SIZE_MEDIUM}
        >
          {productsCount}
        </Label>
      )}
    </Link>
  );
}

export default observer(ComparisonNavItem);
